import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("DueProcessPermissions")
export class DueProcessPermissions {
    static readonly None = 0;
    static readonly View = 1;
    static readonly Edit = 2;
    static readonly Delete = 4;
    static readonly SeeAll = 8;
    // 16 is skipped deliberately — see DueProcessPermissions.cs.
    static readonly Export = 32;
}